import _ from "lodash";
import { SELECT_EMPTY_VALUE, CHART_CTT } from "./constants";

const service = (() => {
  // Validate required state properties on click of View Chart
  const validateViewChart = (state, whiteboardIndex) => {
    // Check Filters
    if (
      _.isUndefined(state.selectedProduct) ||
      state.selectedProduct === SELECT_EMPTY_VALUE ||
      _.isUndefined(state.selectedDateRangeFrom) ||
      _.isUndefined(state.selectedDateRangeTo) ||
      _.isUndefined(state.selectedTradingHour) ||
      state.selectedTradingHour === SELECT_EMPTY_VALUE ||
      _.isUndefined(state.selectedZone) ||
      state.selectedZone === SELECT_EMPTY_VALUE
    )
      return false;

    let whiteboard = state.chartWhiteboards[whiteboardIndex];

    // Check Chart Preferences
    if (
      _.isUndefined(whiteboard.selectedPrimaryChart) ||
      whiteboard.selectedPrimaryChart === SELECT_EMPTY_VALUE ||
      _.isUndefined(whiteboard.selectedPrimaryChartType) ||
      (whiteboard.selectedComparisonChart !== SELECT_EMPTY_VALUE && _.isUndefined(whiteboard.selectedPrimaryChartType)) ||
      _.isUndefined(whiteboard.selectedGranularity) ||
      (whiteboard.selectedPrimaryChart === CHART_CTT && !whiteboard.selectedCostToTradeLotSizes.length)
    )
      return false;

    return true;
  };

  return { validateViewChart };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/validation.js